import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  ExDropdownV2Component,
  ExDropdownV2ContentDirective,
  ExDropdownV2HeaderDirective,
} from '../../../../common-explain/components/ex-dropdown-v2/ex-dropdown-v2.component';
import { FileSubtypeTagSelectorComponent } from '../../file-subtype-tag-selector/file-subtype-tag-selector.component';
import { ResponseDocumentSubtype } from '../../../models/response-document-subtype';

@Component({
  selector: 'app-category-selector',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    ExDropdownV2Component,
    ExDropdownV2HeaderDirective,
    ExDropdownV2ContentDirective,
    FileSubtypeTagSelectorComponent,
  ],
  templateUrl: './category-selector.component.html',
  styleUrls: ['./category-selector.component.scss'],
})
export class CategorySelectorComponent {
  @Input() options: ResponseDocumentSubtype[] = [];
  /** Current display value (subtype displayed name or custom "Autre" text). */
  @Input() value: string | null = null;
  @Input() uncategorized = false;

  readonly optionSelected = output<ResponseDocumentSubtype>();
  readonly customSelected = output<string>();

  onOption(option: ResponseDocumentSubtype, close: () => void): void {
    this.optionSelected.emit(option);
    close();
  }

  onCustom(custom: string, close: () => void): void {
    this.customSelected.emit(custom);
    close();
  }
}
